import React from "react";
import Link from "next/link";
import { google, apple } from "../../assets";

const DownloadApp = () => {
  return (
    <>
      <div className="btns">
        <Link href={`https://apps.apple.com/ng/app/circleplug/id6462672418`}>
          <button className="btn btn--ios" href="#">
            {apple}
            <span className="btn__text">Download on the</span>
            <span className="btn__storename">App Store</span>
          </button>
        </Link>
        <Link
          href={`https://play.google.com/store/apps/details?id=com.shypes.circlePlug`}
        >
          <button className="btn btn--android" href="#">
            {google}
            <span className="btn__text">Get it on</span>
            <span className="btn__storename">Google Play</span>
          </button>
        </Link>
      </div>
    </>
  );
};

export default DownloadApp;
